 <template>
  <div class="footer">
    <div class="links">
      <a title="help" target="_self" href>帮助</a>
      <a title="privacy" target="_self" href>隐私</a>
      <a title="terms" target="_self" href>条款</a>
    </div>
    <div class="copyright">
      Copyright © 2019 广州南方高速铁路测量技术有限公司 <a href="https://beian.miit.gov.cn" target="_blank" style="color:#2c3e50;margin-left:15px">粤ICP备17112196号</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tfooter'
}
</script>

<style lang="scss" scoped>
.footer{
    width: 100%;
    margin: 48px 0 24px;
    position: absolute;
    bottom: 0;
    .links{
        margin-bottom: 8px;
        a{
            margin: 0 20px;
        }
    }
}
</style>
